import React from "react";
import "./loading.scss"; // Assuming you have a loading.scss file for styles

export const Loading = () => {
  return (
    <div className="color-loading">
      <div className="a" />
      <div className="b" />
      <div className="c" />
    </div>
  );
};
